import { Env, WithEnv } from '@/types/envModel';

let devEnv: Partial<Env> = {
  devToolsEnabled: true,
  featureBakkenteller: true,
  featureAgenda: true,
  featurePermissionSwitcher: true,
  featureLmm: true,
  featureWts: true,
  featurePlankMwdDragDrop: true,
  featureReservesV2: true,
  featureSchraplijsten: true,
  featureRedirectToAzure: false,
  featureRedirectToAzureUrl: 'https://bamclient.materieelt.mc.clz.ns.nl/',
  authRedirectUri: 'http://localhost:5173',
  datadogRumEnable: false,
};

const envVariables: () => Partial<Env> = () => {
  const { env } = window as typeof window & WithEnv;

  if (import.meta.env.DEV) {
    return {
      ...devEnv,
    };
  }
  // branchName komt bewust uit een build-time constante (__BRANCH_NAME__) i.p.v. window.env:
  // runtime CI-variabelen bleken onbetrouwbaar (bv. "merge" i.p.v. de echte branchnaam op CEAP).
  return { ...env, branchName: __BRANCH_NAME__ };
};

const injectTestEnv = (testEnvsToInject: Partial<Env>) => {
  devEnv = {
    ...devEnv,
    ...testEnvsToInject,
  };
};

export { envVariables, injectTestEnv };
